module.exports = __webpack_public_path__ + "static/media/ico_status_pass.8aacf1a6.svg";